import 'core-js/stable';
import 'regenerator-runtime/runtime';

import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import Vuetify from 'vuetify';
import vueHeadful from 'vue-headful';

import Api from './api';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

// import styles
import './styles/global.scss';

Api.init();
Vue.use(VeeValidate, {
  classNames: { valid: 'valid', invalid: 'invalid' },
  classes: true,
});
Vue.use(VueScrollTo);
Vue.use(Vuetify);
Vue.component('vue-headful', vueHeadful);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app');
